import React from 'react';
import { LabelType } from '../../../../types/labels';
import { Label } from '../../../Label';

export function MiniHeroContent({
  labels,
  title,
  subTitle,
  cta,
}: {
  labels: LabelType[];
  title: string | null | undefined;
  subTitle: string | null | undefined;
  cta?: React.ReactNode;
}): React.ReactNode {
  const hasSubTitle = Boolean(subTitle);
  const titleClampClass = hasSubTitle ? 'line-clamp-1' : 'line-clamp-2';

  return (
    <div className="absolute inset-x-0 bottom-0 flex flex-col items-start gap-1 p-3 768:gap-3 768:px-3 768:py-4">
      <div className="flex flex-col items-start gap-1 w-full">
        <div className="flex flex-row">
          {labels.map(label => (
            <Label key={label.text} label={label} />
          ))}
        </div>

        {title ? (
          <div className={`text-heading-xs ${titleClampClass} text-white`}>{title}</div>
        ) : null}

        {hasSubTitle ? (
          <div className="text-marker-xs line-clamp-1 text-neutral-400">{subTitle}</div>
        ) : null}
      </div>

      {cta}
    </div>
  );
}
